import { object } from "framer-motion/client";
import { formatDate } from "./utils";
import { useState } from "react";
import { useEffect } from "react";
import { Progress } from "../../../nq-component";

function AuditList({ AuditObjects }) {
  const [objects, setObjects] = useState([]);

  useEffect(() => {
    setObjects(AuditObjects);
  }, [AuditObjects]);

  const headerArray = [
    "Date & Time",
    "User",
    "Action",
    "Module",
    "Description",
  ];

  const actionsColor = {
    CREATE: "#00800099",
    UPDATE: "#2196F3",
    DELETE: "#ff5722d1",
  };

  return (
    <div className="table-responsive rounded shadow-sm border bg-light">
      <table className="table table-hover align-middle mb-0">
        <thead className="bg-light">
          <tr>
            {headerArray.map((header, i) => (
              <th
                key={i}
                className={`text-uppercase text-white fw-bold small border-bottom ${
                  header === "Action"
                    ? "text-center"
                    : header === "Module"
                    ? "text-center"
                    : ""
                }`}
                style={{ backgroundColor: "#e09552" }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {objects && objects.length !== 0 ? (
            objects.map((object, index) => {
              const isApplicant = object?.user?.roles?.some(
                (role) => role?.id === "Applicants"
              );

              const employeeName = `${object?.user?.employee?.firstName} ${object?.user?.employee?.middleName} ${object?.user?.employee?.lastName}`;

              return (
                <tr key={index}>
                  <td className={`border-bottom text-muted`}>
                    <i className="bi bi-clock text-primary me-2"></i>
                    {formatDate(object?.created) || "N/A"}
                  </td>

                  <td className={`border-bottom fw-medium text-truncate`}>
                    <i className="bi bi-person text-primary me-2"></i>
                    {object?.user?.username || "N/A"}

                    {!isApplicant && (
                      <p
                        className="m-0 text-muted"
                        style={{
                          fontSize: "0.8rem",
                          color: "#2196f382",
                        }}
                      >
                        {employeeName}
                      </p>
                    )}
                  </td>

                  <td
                    className={`border-bottom fw-semibold`}
                    style={{
                      color: `${actionsColor[object?.action]}`,
                      fontSize: "0.9rem",
                    }}
                  >
                    <i className="bi bi-lightning-charge text-primary me-2"></i>
                    {object?.action || "N/A"}
                  </td>

                  <td className={`border-bottom text-muted fw-semibold`}>
                    <div
                      className="p-2 rounded-pill d-flex justify-content-center"
                      style={{
                        backgroundColor: isApplicant
                          ? "#8bc34a4d"
                          : "#2196f382",
                        fontSize: "0.8rem",
                      }}
                    >
                      <i className="bi bi-box-seam text-primary me-2"></i>
                      {object?.module || "N/A"}
                    </div>
                  </td>

                  <td className="border-bottom text-muted">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-file-text text-primary me-2"></i>
                      <p
                        className="d-inline-block m-0"
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "250px",
                          whiteSpace: "normal",
                        }}
                      >
                        {object?.description || "No details provided"}
                      </p>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={5}>
                <div className="d-flex justify-content-center fw-semibold text-muted">
                  No data found
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AuditList;
